import { bucketize } from './shouldSendOnce'

export const normalize = {
  journey: (j: any) => ({
    journey_id: j.id,
    journey_name: j.name
  }),

  stage: (s: any) => ({
    stage_id: s.id,
    stage_name: s.name,
    stage_journey_id: s.journey_id
  }),

  level: (l: any) => ({
    level_id: l.id,
    level_name: l.name,
    level_total_point_reward: l.total_point_reward ?? l.point_reward ?? 0,
    level_total_coin_reward: l.total_coin_reward ?? l.coin_reward ?? 0,
    level_finished_percentage: l._finishedPercent,
    level_correct_percentage: l._correctPercent,
    score_bucket: bucketize(l._correctPercent || 0, [0, 50, 80, 95]),
    stage_id: l.stage_id
  }),

  challenge: (c: any) => ({
    challenge_id: c.id,
    challenge_kind: c.kind,
    challenge_position: c.position,
    challenge_point_reward: c.point_reward ?? 0,
    challenge_coin_reward: c.coin_reward ?? 0,
    challenge_time_limit: c.time_limit,
    meta_question_kind: c.meta?.question_kind,
    word_pool_size: bucketize(c.meta?.words?.length || 0, [0, 10, 25, 50]),
    correct_words_count: (c.meta?.words || []).filter((w: any) => w.is_correct)
      .length,
    level_id: c.level_id
  }),

  mission: (m: any) => ({
    mission_id: m.id,
    mission_name: m.name,
    required_levels: m.required_levels,
    completed_levels: m.completed_levels,
    progress_bucket: bucketize(m.completed_levels || 0, [0, 1, 3, 5])
  }),

  document: (d: any, contextSource?: string) => ({
    document_id: d.id ?? d.uid ?? d.slug,
    document_title: (d.title ?? d.name ?? '').slice(0, 50),
    document_type: d.type,
    context_source: contextSource || 'general'
  }),

  search: (query: string, resultsCount: number, context: string) => ({
    query_clean: query.slice(0, 50),
    results_count_bucket: bucketize(resultsCount, [0, 1, 5, 20]),
    context: context
  }),

  listInteraction: (
    interactionType: string,
    resultsCount: number,
    filters?: any
  ) => ({
    interaction_type: interactionType,
    results_count_bucket: bucketize(resultsCount, [0, 5, 20, 50]),
    has_filters: !!filters
  })
}
